export enum ResizeableDraggableStatusEnum {
  None = 0,
  IsResizing = 1,
  IsMoving = 2,
}
